import { ReactNode } from 'react';
import styled from '@emotion/styled';
import Icon from 'presentations/views/components/atoms/Icon';
import Headline from 'presentations/views/components/atoms/Headline';
import { fontSize, spacing } from 'presentations/views/styles';

interface Props {
  iconName: string;
  children: ReactNode;
  color?: string;
}

export default function Component(props: Props) {
  return (
    <BoxHeadline variant="h2">
      <HeadlineIcon
        name={props.iconName}
        color="primary"
        iconColor={props.color}
      />
      <HeadlineText>{props.children}</HeadlineText>
    </BoxHeadline>
  );
}

const BoxHeadline = styled(Headline)`
  display: flex;
  align-items: center;
  font-size: ${fontSize(20)};
`;
const HeadlineText = styled.span`
  margin-left: ${spacing(4)};
`;
const HeadlineIcon = styled(Icon)<{ iconColor?: string }>`
  color: ${({ iconColor }) => iconColor || ''};
  font-size: 30px;
`;
